import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ActionContext from "../../../../context/ActionContext";
import RootState from "../../../../redux/types";
import { useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import {
  colorToRgba,
  formatCustomDate,
  removeSpace,
  VIEWSWITCHLIST,
} from "../../../../utils/helpers";
import {
  RavenBadge,
  RavenCopyText,
  RavenDateTime,
  RavenInputField,
  RavenTable,
  RavenTableRow,
  RavenToolTip,
} from "@ravenpay/raven-bank-ui";
import ExportFragment from "../../../../fragments/ExportFragment";
import PerPageComponent, {
  perPageList,
} from "../../../../fragments/PerPageComponent";
import TwoDetailView from "../../../../fragments/TwoDetailView";
import {
  capitalizeFirstLetter,
  formatNumWithCommaNairaSymbol,
} from "../../../../helper";
import { encrypt2 } from "../../../../utils/encrypt";
import { RouteLinks } from "../../../../routes/RouteLinks";
import { CSVLink } from "react-csv";
import {
  getVirtualTerminals,
  searchVirtualTerminal,
} from "../../../../redux/insight";
import AllMerchantTerminals from "../AllMerchantTerminals";
import NoContentPage from "../../../../fragments/NoContentPage";
import Pagination from "../../../../fragments/pagination";
import useWindowSize from "../../../../utils/UseWindowSize";
import GridListViewSwitch from "../../../../fragments/grid-list-switch/GridViewSwitch";
import TerminalCardComponent from "../common/TerminalCardComponent";

const VirtualTerminalsListView = () => {
  const [search, setSearch] = useState("");
  // const [all_terminals, setAllTerminals] = useState<any>({});
  const size = useWindowSize();
  // const [perPageVal, setPerPageVal] = useState({ label: "10", value: 10 })
  const dispatch = useDispatch();
  const actionCtx = useContext(ActionContext);
  const [currentPage, setCurrentPage] = useState(1);
  const {
    loading,
    insight_terminals,
    all_virtual_terminals,
    all_device_request,
    loading_vir,
  } = useSelector((state: RootState) => state.insights);
  const [dataExist, setDataExist] = useState(false);
  const handlefetchVirtualTerminal = async () => {
    // console.log("hsgfghj");

    if (!search) {
      const obj = {
        per_page: actionCtx?.perPageGlobalVal?.value,
        page: currentPage || 1,
        status: "",
      };
      const data = await dispatch(getVirtualTerminals(obj as any) as any);

      if (data?.payload?.status === "success") {
        const list = data?.payload?.data?.data?.data;
        if (list?.length > 0) {
          setDataExist(true);
        }
      } else {
        // console.error("Request failed:", data);
      }
    }
  };

  useEffect(() => {
    if (Object?.keys(actionCtx?.configDetails)?.length > 0) {
      handlefetchVirtualTerminal();
    }
  }, [
    actionCtx?.perPageGlobalVal,
    actionCtx?.configDetails,
    currentPage,
    search,
  ]);

  const CsvHeader = [
    { label: "S/N", key: "num" },
    { label: "TERMINAL LABEL", key: "tid_label" },
    { label: "TERMINAL ID", key: "tid" },
    { label: "SERIAL NO", key: "serial" },
    { label: "CASH IN", key: "cash_in" },
    { label: "DATE CREATED", key: "created_at" },

    { label: "STATUS", key: "status" },
  ];
  const tableList = [
    "TERMINAL LABEL",
    "SERIAL NO.",
    "CASH IN",
    "DATE CREATED",
    "STATUS",
  ];

  const formatExportData = (data: any) => {
    if (data?.length > 0) {
      const list = data?.map((chi: any, idx: any) => {
        return {
          num: idx < 10 ? `0${idx + 1}` : idx + 1,
          tid_label: capitalizeFirstLetter(chi?.tid_label),
          tid: chi?.tid,
          serial: chi?.serial,
          card_in: formatNumWithCommaNairaSymbol(String(chi?.card_in)),
          created_at: formatCustomDate(chi?.created_at),
          // cal: formatNumWithCommaNairaSymbol(
          //   String(Number(chi?.transfer_volume) + Number(chi?.card_volume))
          // ),
          status: "success",
        };
      });
      return list;
    }
  };

  const navigate = useNavigate();

  const handleSearchVirtual = debounce(async () => {
    const searchTerm = search?.trim();

    if (searchTerm) {
      dispatch(searchVirtualTerminal({ search: searchTerm }) as any);
    }
  }, 500);

  useEffect(() => {
    if (removeSpace(String(search))?.length > 0) {
      handleSearchVirtual();
    }
  }, [search]);

  const switchNum = 10;
  const [viewMode, setViewMode] = useState(VIEWSWITCHLIST[0]);

  useEffect(() => {
    if (
      all_virtual_terminals?.data?.length > switchNum &&
      Number(size?.width) > 900
    ) {
      actionCtx?.setViewListMode(VIEWSWITCHLIST[1]);
      setViewMode(VIEWSWITCHLIST[1]);
    } else {
      setViewMode(VIEWSWITCHLIST[0]);
      actionCtx?.setViewListMode(VIEWSWITCHLIST[0]);
    }
  }, [size]);

  return (
    <AllMerchantTerminals
      loading={loading_vir}
      noContent={
        Object?.keys(all_virtual_terminals)?.length < 1 &&
        Object?.keys(insight_terminals)?.length < 1 &&
        Object?.keys(all_device_request)?.length < 1 &&
        !dataExist
      }
    >
      <div
        // onClick={() => {
        //   console.log(all_virtual_terminals);
        // }}
        className="all-terminal-dashboard-index-wrap"
      >
        {all_virtual_terminals?.data?.length > 0 || dataExist ? (
          <div className="search-export-filter-box">
            {/* search box start */}
            <form
              action=""
              onSubmit={(e) => {
                e.preventDefault();
              }}
              className="search-box"
              autoComplete="off"
            >
              <RavenInputField
                color="green-light"
                type="search"
                placeholder="Search Terminals by TID & Serial No."
                value={search}
                onChange={(e: any) => {
                  const val = removeSpace(String(e.target.value));
                  setSearch(val);
                  if (val?.length < 1) {
                    handlefetchVirtualTerminal();
                  }
                }}
              />
            </form>
            {/* search box end */}
            {/* filter-export pagination box start */}
            <div className="filter-export-pagination-box">
              {/* <FilterFragment page="all-transactions" /> */}

              <CSVLink
                // ref={download}

                className="export-table-content-box tooltip-hover-wrap grey-bg"
                filename={"All Virtual Terminals.csv"}
                data={formatExportData(all_virtual_terminals?.data) || ""}
                headers={CsvHeader}
              >
                {" "}
                <RavenToolTip
                  color="deep-green-light"
                  text="Export Table Content"
                  position={`left`}
                />
                <ExportFragment
                // onClick={() => {
                //   handleExport();
                // }}
                />
              </CSVLink>
              <Pagination
                currentPage={currentPage}
                itemsPerPage={all_virtual_terminals?.pagination?.perPage || 0}
                totalItems={all_virtual_terminals?.pagination?.totalItems || 0}
                onPageChange={(param: number) => {
                  setCurrentPage(param);
                }}
                loading={loading_vir}
              />
              {all_virtual_terminals?.pagination?.totalItems >
                perPageList[0]?.value && (
                <PerPageComponent
                  setPerPageVal={(param) => {
                    setCurrentPage(1);
                  }}
                />
              )}
              {Number(size?.width) > 900 && (
                <GridListViewSwitch
                  onManualSwitch={(param) => {
                    setViewMode(param);
                  }}
                />
              )}
            </div>
            {/* filter-export pagination box end */}
          </div>
        ) : (
          ""
        )}
        {/* content here start */}
        {Object?.keys(all_virtual_terminals)?.length < 1 ? (
          <>
            <NoContentPage
              styles={{
                height: "calc(100vh - 40rem)",
                border: "unset",
                boxShadow: "unset",
                padding: "unset",
              }}
              loading={loading_vir}
            />
          </>
        ) : (
          <>
            <div
              // onClick={() => {
              //   console.log(all_virtual_terminals);
              // }}
              className="table-content-box"
            >
              {/* big table start  */}

              {actionCtx?.viewListMode?.value === VIEWSWITCHLIST[1]?.value ? (
                <div className="big-table">
                  <RavenTable headerList={tableList}>
                    {all_virtual_terminals?.data?.map((chi: any, idx: any) => {
                      // if (all_virtual_terminals?.data?.length < 9) {
                      //   return <React.Fragment key={idx}></React.Fragment>;
                      // }
                      return (
                        <RavenTableRow
                          loading={loading_vir}
                          key={idx}
                          one={
                            <TwoDetailView
                              title={
                                chi?.tid_label
                                  ? capitalizeFirstLetter(chi?.tid_label)
                                  : "---"
                              }
                              text_one={
                                chi?.tid ? (
                                  <RavenCopyText
                                    stopPropagation
                                    copyIconColor="var(--primary-base-color)"
                                    copyIconBgColor={colorToRgba(
                                      "var(--primary-base-color)",
                                      0.1
                                    )}
                                    copiedBgColor=" var(--primary-base-color)"
                                    trimNum={35}
                                    text={`TID: ${chi?.tid || ""}`}
                                    copyValue={chi?.tid}
                                  />
                                ) : (
                                  ("" as any)
                                )
                              }
                            />
                          }
                          two={
                            <RavenCopyText
                              color="deep-green-light"
                              text={chi?.serial}
                              stopPropagation
                              copyIconColor="var(--primary-base-color)"
                              copyIconBgColor={colorToRgba(
                                "var(--primary-base-color)",
                                0.1
                              )}
                              copiedBgColor=" var(--primary-base-color)"
                              trimNum={35}
                            />
                          }
                          three={
                            <TwoDetailView
                              title={formatNumWithCommaNairaSymbol(
                                String(chi?.cash_in)
                              )}
                              text_one={chi?.transaction_count}
                            />
                          }
                          // three={chi?.t_id || "---"}
                          four={<RavenDateTime date={chi?.created_at} />}
                          five={
                            // <TwoDetailView
                            //   // text_one={chi?.bank_count}
                            //   title={formatNumWithCommaNairaSymbol(
                            //     String(
                            //       Number(chi?.transfer_volume) +
                            //         Number(chi?.card_volume)
                            //     )
                            //   )}
                            //   // text_two={chi?.stan}
                            // />
                            <RavenBadge
                              type={Number(chi?.status) === 1 ? "green" : `red`}
                              text={
                                Number(chi?.status) === 1
                                  ? `Active`
                                  : `Inactive`
                              }
                            />
                          }
                          onRowClick={async () => {
                            //   console.log(chi);

                            const encryptedSerial = await encrypt2(
                              chi?.serial ?? ""
                            );
                            localStorage?.setItem("takwoski", encryptedSerial);
                            navigate(RouteLinks?.Terminal_details);
                          }}
                          // six={chi?.date}
                        />
                      );
                    })}
                  </RavenTable>
                </div>
              ) : (
                <>
                  <div
                    className={`physical-card-general-display-box ${
                      actionCtx?.viewListMode?.value ===
                        VIEWSWITCHLIST[0]?.value &&
                      all_virtual_terminals?.data?.length < 5
                        ? "physical-card-general-display-box-flex"
                        : ""
                    }`}
                  >
                    {" "}
                    {all_virtual_terminals?.data?.map((chi: any, idx: any) => {
                      const { tid_label, serial, volume, tid, status } =
                        chi || {};
                      return (
                        <TerminalCardComponent
                          details={chi}
                          key={idx}
                          status={status}
                          loading={loading || loading_vir}
                          serial={serial}
                          tid={tid}
                          tid_label={tid_label}
                        />
                      );
                    })}
                  </div>
                </>
              )}
              {/* big table end */}

              {/* mobile wrap table start */}
              {/* <div className="mobile-table-box">
                {all_virtual_terminals?.data?.map((chi: any, idx: any) => {
                  return (
                    <MobileTableCard
                      amountColor={``}
                      text={
                        chi?.tid ? (
                          <RavenCopyText
                            stopPropagation
                            copyIconColor="var(--primary-base-color)"
                            copyIconBgColor={colorToRgba(
                              "var(--primary-base-color)",
                              0.1
                            )}
                            copiedBgColor=" var(--primary-base-color)"
                            trimNum={35}
                            text={`TID: ${chi?.tid || ""}`}
                            copyValue={chi?.tid}
                          />
                        ) : (
                          ("" as any)
                        )
                      }
                      textTwo={
                        chi?.serial ? (
                          <RavenCopyText
                            color="deep-green-light"
                            text={`Serial: ${chi?.serial}`}
                            stopPropagation
                            copyIconColor="var(--primary-base-color)"
                            copyIconBgColor={colorToRgba(
                              "var(--primary-base-color)",
                              0.1
                            )}
                            copiedBgColor=" var(--primary-base-color)"
                            trimNum={25}
                          />
                        ) : (
                          ("" as any)
                        )
                      }
                      title={capitalizeFirstLetter(chi?.tid_label) || "---"}
                      amount={
                        formatNumWithCommaNairaSymbol(
                          String(Number(chi?.cash_in))
                        ) || "---"
                      }
                      key={idx}
                      onRowClick={async () => {
                        const encryptedSerial = await encrypt2(
                          chi?.serial ?? ""
                        );
                        localStorage?.setItem("takwoski", encryptedSerial);
                        navigate(RouteLinks?.Terminal_details);
                      }}
                      avatar={chi?.tid_label}
                      showImg
                      //   img={}
                      //   smallText={ref}
                      //   type={chi?.direction || " "}
                    />
                  );
                })}
              </div> */}
              {/* mobile wrrap table end */}
            </div>
          </>
        )}
        {/* content here end */}
      </div>
    </AllMerchantTerminals>
  );
};

export default VirtualTerminalsListView;
